
import {map, flatMap} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';

import {
  AppSettingsService,
  AuthenticationService,
  BaseService,
  ServiceManager,
} from 'iui-iconectiv-lib';

import { QueryPaging } from '../shared';
import { GenericResponse } from '../shared';


export class AccountListResponse extends GenericResponse  {
  accountListResponse: any;
}

@Injectable()
  export class ServiceDeskService extends BaseService {

    headers: HttpHeaders = new HttpHeaders();

    constructor(
      serviceManager: ServiceManager,
      private http: HttpClient,
      private appSettings: AppSettingsService,
      private  authService: AuthenticationService
    ) {
      super(serviceManager);

      this.headers.append('Content-Type', 'application/json');
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${this.authService.getToken()}`
      }
    });
    //console.log('new headers', request.headers.keys());
    return next.handle(request);
  }

  intercept1(req: HttpRequest<any>,
    next: HttpHandler): Observable<HttpEvent<any>> {

    const clonedRequest = req.clone({
      headers: req.headers.set(
        'Authorization',
        this.authService.getToken()
      )
    });
    //console.log('new headers', clonedRequest.headers.keys());
    return next.handle(clonedRequest);
  }


  getAccountList(authenticationToken: string): Observable<AccountListResponse> {

    return this.emitObservable(this.appSettings.getSettings().pipe(flatMap(settings => {
      let params = new HttpParams().append('limit', (settings['sdaccounts'] || '1000'));
      const url = this.getServer(settings) + '/api/account/list';
      return this.http.get(url, { responseType: 'text', params: params,
       headers: new HttpHeaders().append('Content-Type', 'application/json').append('Authorization', authenticationToken)
    }).pipe(map(res => {
        const r = this.parseToType<AccountListResponse>(res);
        return r;
      }));
    })));
  }


  postChangedStatus(accountId: string, changedStatus: string, reason: string, notificationDate: String, effectiveDate: String): Observable<any> {
    return this.emitObservable(this.appSettings.getSettings().pipe(flatMap(settings => {
      const url = this.getServer(settings) + `/api/account/status/${accountId}?status=${changedStatus}&reason=${reason}&notificationDate=${notificationDate}&effectiveDate=${effectiveDate}`;
      return this.http.post(url, null, {
        headers: new HttpHeaders().append('Content-Type', 'application/json')
          .append('Authorization', this.authService.getToken())
      });
    })));
  }

  getUsersWithId(accountId?: string, limit?: number, sortBy?: string, sort?: string, page?: number): Observable<any> {
    return this.emitObservable(this.appSettings.getSettings().pipe(flatMap(settings => {
      const url = this.getServer(settings) + `/iSec/secure/user/account/${accountId}?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}`;
      return this.http.get(url, {
        headers: new HttpHeaders().append('Content-Type', 'application/json')
          .append('Authorization', this.authService.getToken())
      });
    })));
  }
}
